import React, {FC} from 'react';
import {Drop} from '../../../../grpc_client/grips/protos/shared/drop';
import {useDropsTranslationContext} from '../../../../pages/Drops/context/TranslationProvider';
import {SectionTrackingContextProvider} from '../../../../tracking/context/SectionTrackingContext';
import {
  SectionSeparator,
  SeparatorCategory,
  SeparatorTitle,
  TeaserContainer,
} from '../DropOverviewStyles';
import {UpcomingDrop} from './UpcomingDrop';

export const UpcomingDrops: FC<{
  upcomingDrops: Drop[];
}> = ({upcomingDrops}) => {
  const translations = useDropsTranslationContext();

  if (upcomingDrops.length === 0) {
    return null;
  }

  return (
    <SectionTrackingContextProvider>
      <SectionSeparator>
        <SeparatorCategory>
          {translations.overview.sections.upcoming.subHeadline}
        </SeparatorCategory>
        <SeparatorTitle>
          {translations.overview.sections.upcoming.headline}
        </SeparatorTitle>
      </SectionSeparator>
      <TeaserContainer>
        {upcomingDrops.map(drop => (
          <UpcomingDrop key={drop.id} drop={drop} />
        ))}
      </TeaserContainer>
    </SectionTrackingContextProvider>
  );
};
